import {useApi} from "~/composables/api/utils/useApi"

export const useDeliveryMethodApi = () => ({
  async getList() {
    const url = `delivery-methods`
    const api = useApi()

    return api.makeRequest(url, 'get')
  },

  async calculateAmountById(methodId, country, postalCode, location = null) {
    let url = `delivery-methods/${methodId}?country=${country}&postal_code=${postalCode}`
    if (location) {
      url += `&location=${location}`
    }

    const api = useApi()

    return api.makeRequest(url, 'get')
  },

  async getById(methodId) {
    const url = `delivery-methods/${methodId}`
    const api = useApi()

    return api.makeRequest(url, 'get')
  }
})
